export const ErrorStatusTypes = {
    RETAILER_LIMIT: 100,
    DAILY_LIMIT: 101,
    CAMPAIGN_LIMIT: 102,
    CAMPAIGN_OFF: 103,
    RETAILER_OFF: 104,
    ALREADY_SIGNUP: 105,
    ALREADY_REDEEMED_NO_LIMIT: 106,
    VENUE_OFF: 107,
    NO_LOCATION: 200,
    INSTANT_WIN_USER_NOT_FOUND: 1001,
    INSTANT_WIN_USER_NOT_WINNER: 1002,
    INSTANT_WIN_USER_LINK_EXPIRED: 1003,
    INSTANT_WIN_USER_ALREADY_CLAIMED: 1004,
    INSTANT_WIN_USER_ALREADY_ACTIVATED: 1005,
    INSTANT_WIN_USER_TOO_EARLY: 1006,
    GAME_NOT_STARTED: 2001,
    GAME_IN_PROGRESS: 2002,
    PREDICTION_WRONG: 2003,
    USER_NOT_PREDICTED_YET: 2004,
    LOYALTY_COME_BACK_LATER: 3001,
    LOYALTY_COMPLETED: 3002,
    LOYALTY_NOT_COMPLETED: 3003,
};
